/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The SimplifiedVectorSummary model module.
 * @module model/SimplifiedVectorSummary
 * @version v0
 */
export default class SimplifiedVectorSummary {
  /**
   * Constructs a new <code>SimplifiedVectorSummary</code>.
   * @alias module:model/SimplifiedVectorSummary
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SimplifiedVectorSummary</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SimplifiedVectorSummary} obj Optional instance to populate.
   * @return {module:model/SimplifiedVectorSummary} The populated <code>SimplifiedVectorSummary</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SimplifiedVectorSummary();
      if (data.hasOwnProperty('numberOfMissings'))
        obj.numberOfMissings = ApiClient.convertToType(data['numberOfMissings'], 'Number');
      if (data.hasOwnProperty('numberOfEmpties'))
        obj.numberOfEmpties = ApiClient.convertToType(data['numberOfEmpties'], 'Number');
      if (data.hasOwnProperty('numberOfMissingsOrEmpties'))
        obj.numberOfMissingsOrEmpties = ApiClient.convertToType(data['numberOfMissingsOrEmpties'], 'Number');
      if (data.hasOwnProperty('allDictionaryWords'))
        obj.allDictionaryWords = ApiClient.convertToType(data['allDictionaryWords'], 'Boolean');
      if (data.hasOwnProperty('uniform'))
        obj.uniform = ApiClient.convertToType(data['uniform'], 'Boolean');
      if (data.hasOwnProperty('specialUniform'))
        obj.specialUniform = ApiClient.convertToType(data['specialUniform'], 'Boolean');
      if (data.hasOwnProperty('uniformType'))
        obj.uniformType = ApiClient.convertToType(data['uniformType'], 'String');
      if (data.hasOwnProperty('numberOfUniques'))
        obj.numberOfUniques = ApiClient.convertToType(data['numberOfUniques'], 'Number');
      if (data.hasOwnProperty('numberOfduplicates'))
        obj.numberOfduplicates = ApiClient.convertToType(data['numberOfduplicates'], 'Number');
      if (data.hasOwnProperty('highestNumberOfRepeats'))
        obj.highestNumberOfRepeats = ApiClient.convertToType(data['highestNumberOfRepeats'], 'Number');
      if (data.hasOwnProperty('numberOfStrings'))
        obj.numberOfStrings = ApiClient.convertToType(data['numberOfStrings'], 'Number');
      if (data.hasOwnProperty('numberOfNumbers'))
        obj.numberOfNumbers = ApiClient.convertToType(data['numberOfNumbers'], 'Number');
      if (data.hasOwnProperty('numberOfDates'))
        obj.numberOfDates = ApiClient.convertToType(data['numberOfDates'], 'Number');
      if (data.hasOwnProperty('meanNumber'))
        obj.meanNumber = ApiClient.convertToType(data['meanNumber'], 'Number');
      if (data.hasOwnProperty('lowestNumber'))
        obj.lowestNumber = ApiClient.convertToType(data['lowestNumber'], 'Number');
      if (data.hasOwnProperty('highestNumber'))
        obj.highestNumber = ApiClient.convertToType(data['highestNumber'], 'Number');
      if (data.hasOwnProperty('numberStandardDeviation'))
        obj.numberStandardDeviation = ApiClient.convertToType(data['numberStandardDeviation'], 'Number');
      if (data.hasOwnProperty('medianNumber'))
        obj.medianNumber = ApiClient.convertToType(data['medianNumber'], 'Number');
      if (data.hasOwnProperty('numberFirstQuartile'))
        obj.numberFirstQuartile = ApiClient.convertToType(data['numberFirstQuartile'], 'Number');
      if (data.hasOwnProperty('numberThirdQuartile'))
        obj.numberThirdQuartile = ApiClient.convertToType(data['numberThirdQuartile'], 'Number');
      if (data.hasOwnProperty('lowestDate'))
        obj.lowestDate = ApiClient.convertToType(data['lowestDate'], 'String');
      if (data.hasOwnProperty('highestDate'))
        obj.highestDate = ApiClient.convertToType(data['highestDate'], 'String');
      if (data.hasOwnProperty('medianDate'))
        obj.medianDate = ApiClient.convertToType(data['medianDate'], 'String');
      if (data.hasOwnProperty('dateFirstQuartile'))
        obj.dateFirstQuartile = ApiClient.convertToType(data['dateFirstQuartile'], 'String');
      if (data.hasOwnProperty('dateThirdQuartile'))
        obj.dateThirdQuartile = ApiClient.convertToType(data['dateThirdQuartile'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} numberOfMissings
 */
SimplifiedVectorSummary.prototype.numberOfMissings = undefined;

/**
 * @member {Number} numberOfEmpties
 */
SimplifiedVectorSummary.prototype.numberOfEmpties = undefined;

/**
 * @member {Number} numberOfMissingsOrEmpties
 */
SimplifiedVectorSummary.prototype.numberOfMissingsOrEmpties = undefined;

/**
 * @member {Boolean} allDictionaryWords
 */
SimplifiedVectorSummary.prototype.allDictionaryWords = undefined;

/**
 * @member {Boolean} uniform
 */
SimplifiedVectorSummary.prototype.uniform = undefined;

/**
 * @member {Boolean} specialUniform
 */
SimplifiedVectorSummary.prototype.specialUniform = undefined;

/**
 * @member {String} uniformType
 */
SimplifiedVectorSummary.prototype.uniformType = undefined;

/**
 * @member {Number} numberOfUniques
 */
SimplifiedVectorSummary.prototype.numberOfUniques = undefined;

/**
 * @member {Number} numberOfduplicates
 */
SimplifiedVectorSummary.prototype.numberOfduplicates = undefined;

/**
 * @member {Number} highestNumberOfRepeats
 */
SimplifiedVectorSummary.prototype.highestNumberOfRepeats = undefined;

/**
 * @member {Number} numberOfStrings
 */
SimplifiedVectorSummary.prototype.numberOfStrings = undefined;

/**
 * @member {Number} numberOfNumbers
 */
SimplifiedVectorSummary.prototype.numberOfNumbers = undefined;

/**
 * @member {Number} numberOfDates
 */
SimplifiedVectorSummary.prototype.numberOfDates = undefined;

/**
 * @member {Number} meanNumber
 */
SimplifiedVectorSummary.prototype.meanNumber = undefined;

/**
 * @member {Number} lowestNumber
 */
SimplifiedVectorSummary.prototype.lowestNumber = undefined;

/**
 * @member {Number} highestNumber
 */
SimplifiedVectorSummary.prototype.highestNumber = undefined;

/**
 * @member {Number} numberStandardDeviation
 */
SimplifiedVectorSummary.prototype.numberStandardDeviation = undefined;

/**
 * @member {Number} medianNumber
 */
SimplifiedVectorSummary.prototype.medianNumber = undefined;

/**
 * @member {Number} numberFirstQuartile
 */
SimplifiedVectorSummary.prototype.numberFirstQuartile = undefined;

/**
 * @member {Number} numberThirdQuartile
 */
SimplifiedVectorSummary.prototype.numberThirdQuartile = undefined;

/**
 * @member {String} lowestDate
 */
SimplifiedVectorSummary.prototype.lowestDate = undefined;

/**
 * @member {String} highestDate
 */
SimplifiedVectorSummary.prototype.highestDate = undefined;

/**
 * @member {String} medianDate
 */
SimplifiedVectorSummary.prototype.medianDate = undefined;

/**
 * @member {String} dateFirstQuartile
 */
SimplifiedVectorSummary.prototype.dateFirstQuartile = undefined;

/**
 * @member {String} dateThirdQuartile
 */
SimplifiedVectorSummary.prototype.dateThirdQuartile = undefined;

